import { CustomTabPanel } from "@/erp/sale";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { a11yProps, sizeTab } from "@/shared";
import { useState } from "react";
import TabRutasTroncal from "../components/TabRutasTroncal";


export default function CoberturaCorporativaPage() {
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Cobertura Corporativa"}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Rutas Troncal'} {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TabRutasTroncal />
      </CustomTabPanel>

    </SingleTableBoxScene>
  )
}
